export const drawers = {
  namespaced: true,
  state: {
    showLeftPanel: true,
    showRightPanel: false,
  },
  mutations: {
    toggleLeftPanel(state, val) {
      state.showLeftPanel = val;
    },
    toggleRightPanel(state, val) {
      state.showRightPanel = val;
    },
  },
};
